export enum Events {
  CONVERSATION_LIST_CHANGED = 'conversation_list_changed',
  CONNECTION_CHANGED = 'connection_changed',
  NEW_MESSAGE = 'new_message',
  NEW_BROADCAST_MESSAGE = 'new_broadcast_message',
  EDITED_MESSAGE = 'edited_message',
  HAS_STARTED_TYPING = 'started_typing',
  HAS_STOPPED_TYPING = 'stopped_typing',
  NEW_CONVERSATION = 'new_conversation',
  CONVERSATION_LIST_META_CHANGED = 'conversation_list_meta_changed',
  BROADCAST_LIST_META_CHANGED = 'broadcast_list_meta_changed',
  DELETED_MESSAGE = 'deleted_message',
  UPLOAD_FAILED = 'upload_failed',
}
